<template>
    <div class="js-menu">
        <el-menu v-if="zeroMenu.length>0" default-active="-1" class :router="true" background-color="#545c64" text-color="#fff" active-text-color="#67C23A" @open="handleOpen" :unique-opened="true" @close="handleClose">
            <el-menu-item index="-1" :route="{ name: 'home' }">首页</el-menu-item>
            <div v-for="(item,index) in zeroMenu" :key="index">
                <el-menu-item :index="index + ''" v-if="item.bindurl" :route="{ name: item.bindurl }">{{item.name}}</el-menu-item>
                <el-submenu :index="index + ''" v-else>
                    <template slot="title">
                        <span v-text="item.name"></span>
                    </template>
                    <div v-for="(firstItem,firstIndex) in firstMenu" :key="firstIndex">
                        <el-menu-item :index="index+'-'+firstIndex" v-if="firstItem.parentId == item.id" :route="{ name: firstItem.bindurl, query: firstItem.parameter}">{{firstItem.name}}</el-menu-item>
                    </div>
                </el-submenu>
            </div>
        </el-menu>
    </div>
</template>
<script>
export default {
    data() {
        return {
            menus: [],
            zeroMenu: [],
            firstMenu: [],
            secondMenu: [],
            firstMenuParentId: [],
            sencondMenuParentId: [],

            hospital: '',
            agent: '',
            admin: '1'
        };
    },
    mounted() {
        var _this = this;
        _this.menus = _this.$common.cache("menusList") || [];
        var menus = _this.$common.cache("menusList") || [];
        for (var i in menus) {
            var _item = menus[i];
            if (0 == menus[i].level) {
                if (_item.parameter) {
                    _item.parameter = eval("(" + _item.parameter + ")");
                } else {
                    _item.parameter = eval("({})");
                }
                _this.zeroMenu.push(_item);
            } else if (1 == menus[i].level) {
                if (_item.parameter) {
                    _item.parameter = eval("(" + _item.parameter + ")");
                } else {
                    _item.parameter = eval("({})");
                }
                _this.firstMenu.push(_item);
                _this.firstMenuParentId.push(_item.parentId);
            }
        }
       // var url = window.location.hash;
    },
    methods: {
        handleOpen() {

        },
        handleClose() {

        }
    },
};
</script>
<style scoped>
</style>